/**
 * Module dependencies.
 */

import React, { createContext, ReactNode, useContext } from 'react';
import { FieldValues, UseFormReturn } from 'react-hook-form';

/**
 * `Props` type.
 */

type Props = {
  form: UseFormReturn<FieldValues, any>;
  children: ReactNode;
};

/**
 * `CrudFormContext` context.
 */

const CrudFormContext = createContext<UseFormReturn<FieldValues, any>>(null as any);

/**
 * `useCrudForm` hook.
 */

export const useCrudForm = () => {
  const context = useContext(CrudFormContext);
  if (context === null) {
    throw new Error('[useCrudForm] no context found. Make sure you are using it within a CrudFormProvider.');
  }
  return context;
};

/**
 * Export `CrudFormProvider` component.
 */

export function CrudFormProvider({ form, children }: Props): JSX.Element {
  if (!form) {
    console.error('[CrudFormProvider] form is null');
  }

  return <CrudFormContext.Provider value={form}>{children}</CrudFormContext.Provider>;
}
